import { Box, Typography } from '@mui/material'
import { MOBILE_MQ, mobileBodyTextSx } from '../../theme/mobileLayout'

const bodySx = {
  ...mobileBodyTextSx,
  fontSize: { xs: 16, sm: 22, md: 24 },
}

const headingSx = {
  fontSize: { xs: 22, sm: 30, md: 30 },
  lineHeight: 'normal',
  fontWeight: 400,
  color: '#111',
}

const listSx = {
  ...bodySx,
  pl: { xs: 2.5, md: '36px' },
  m: 0,
  listStyleType: 'disc',
  '& li': {
    mb: 0,
    '& + li': {
      mt: 0,
    },
  },
}

function StorySection({ section }) {
  if (section.type === 'intro') {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
        {section.paragraphs.map((paragraph) => (
          <Typography key={paragraph} sx={bodySx}>
            {paragraph}
          </Typography>
        ))}
      </Box>
    )
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
      <Typography component="h2" sx={headingSx}>
        {section.heading}
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
        {section.paragraphs?.map((paragraph) => (
          <Typography key={paragraph} sx={bodySx}>
            {paragraph}
          </Typography>
        ))}
        {section.list && (
          <Box component="ul" sx={listSx}>
            {section.list.map((item) => (
              <Box component="li" key={item} sx={{ display: 'list-item' }}>
                {item}
              </Box>
            ))}
          </Box>
        )}
        {section.closingParagraphs?.map((paragraph) => (
          <Typography key={paragraph} sx={bodySx}>
            {paragraph}
          </Typography>
        ))}
      </Box>
    </Box>
  )
}

export default function StoryArticleBody({ sections }) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '40px',
        width: '100%',
        [MOBILE_MQ]: { gap: '32px' },
      }}
    >
      {sections.map((section) => (
        <StorySection key={section.heading || section.paragraphs[0]} section={section} />
      ))}
    </Box>
  )
}
